'use client';

import React from 'react';
import Button from '@/components/Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service here
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container min-vh-100 d-flex align-items-center justify-content-center">
          <div className="text-center">
            <h1 className="display-4 mb-4">Oups! Une erreur est survenue</h1>
            <p className="lead mb-5">
              Nous nous excusons pour ce désagrément. Veuillez réessayer ou retourner à la page
              d&apos;accueil.
            </p>
            <div className="d-flex gap-3 justify-content-center">
              <Button onClick={() => (window.location.href = '/')} className="btn btn-primary">
                Retour à l&apos;accueil
              </Button>
              <Button onClick={() => window.location.reload()} className="btn btn-outline-primary">
                Rafraîchir la page
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
